// src/components/BottomNavBar.js
import { Home, Calendar, BarChart2, Menu, PlusCircle } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

export default function BottomNavBar() {
  const { pathname } = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t flex justify-around items-center h-16 shadow">
      <NavButton
        to="/"
        icon={<Home size={28} />}
        label="Home"
        active={pathname === "/"}
      />
      <NavButton
        to="/calendar"
        icon={<Calendar size={28} />}
        label="Calendar"
        active={pathname === "/calendar"}
      />
      {/* Add button center */}
      <div className="-mt-8 z-10">
        <Link to="/add">
          <button className="bg-gradient-to-tr from-pink-400 to-blue-400 rounded-full w-16 h-16 flex items-center justify-center shadow-xl border-4 border-white hover:scale-105 transition">
            <PlusCircle size={36} color="#fff" />
          </button>
        </Link>
      </div>
      <NavButton
        to="/infographic"
        icon={<BarChart2 size={28} />}
        label="Infographic"
        active={pathname === "/infographic"}
      />
      <NavButton
        to="/more"
        icon={<Menu size={28} />}
        label="More"
        active={pathname === "/more"}
      />
    </nav>
  );
}

function NavButton({ to, icon, label, active }) {
  return (
    <Link to={to} className="flex flex-col items-center justify-center w-14">
      <span className={active ? "text-indigo-500" : "text-gray-400"}>
        {icon}
      </span>
      <span className={`text-xs mt-1 ${active ? "text-indigo-500 font-bold" : "text-gray-400"}`}>{label}</span>
    </Link>
  );
}